import React, { useState } from 'react';

type ImgProps = React.ImgHTMLAttributes<HTMLImageElement>;

interface Props extends ImgProps {
    /** Wraps the image in its frame (link, border …). Not rendered at all if the image fails. */
    frame?: (img: React.ReactElement) => React.ReactNode;
}

/**
 * An image that removes itself, frame included, when the file can't be loaded,
 * so a missing upload never shows as a broken-image box.
 */
export const OptionalImage: React.FC<Props> = ({ frame = img => img, onError, ...imgProps }) => {
    const [failed, setFailed] = useState(false);
    if (failed) return null;

    const img = (
        <img
            {...imgProps}
            onError={e => { setFailed(true); onError?.(e); }}
        />
    );
    return <>{frame(img)}</>;
};
